import styled from '@emotion/styled'
import { wrap as withStyle } from 'utils/styles'

import { Icon } from 'components/patterns'

export default withStyle(
  () => `
    display: flex;
    margin: 0;
    padding: 0;
    height: 32px;
    input {
      padding-right: 50px;
    }
    .ant-input-group-addon {
      position: absolute;
      right: 0;
      top: 0;
      bottom: 0;
      background: none;
      border: none;
      width: 50px;
      padding: 0;
      display: flex;
      justify-content: space-around;
      align-items: center;
      z-index: 1;
      > svg {
        width: 15px;
        height: 15px;
        line-height: 18px;
      }
      .chec-icon--cancel {
        width: 29px;
        height: 24px;
        padding-left: 8px;
        margin-left: 7px;
        padding-right: 8px;
        border-left: 1px solid #e3e5e8;
      }
    }
  `
)

export const SearchIcon = styled(Icon)(
  (props) => `
  cursor: ${props.disabled ? 'initial' : 'pointer'};
`
)
